import * as amplitude from '@amplitude/analytics-browser';

const AMPLITUDE_API_KEY = '181d9cdd4c5b01e5b2f8c7e4b7146e46';

export const initAmplitude = () => {
    amplitude.init(AMPLITUDE_API_KEY, {
        defaultTracking: true, // автоматически отслеживает page views, session start и т.д.
        identityStorage: "localStorage" // Избегает блокировок cookies
    });
};

export const logEvent = (eventName, eventProperties = {}) => {
    amplitude.track(eventName, eventProperties);
};

export const registerUser = (userMail = {}) => {
    amplitude.setUserId(userMail);
};

